import { CustomClaimMessages, TranslationCustomClaimMessages } from "../interfaces";

export const messages: TranslationCustomClaimMessages = {
  [CustomClaimMessages.defaultClaims]: "Default group right",
  [CustomClaimMessages.additionalUserClaim]: "Custom privilege",
  [CustomClaimMessages.restrictedUserClaim]: "Custom restriction"
};